import type { Asserts } from 'yup';

import { baseSchema } from '@/features/Input/inputBaseSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { hunSchema } from '@/features/Sparten/hun/schema/schema';

export const inputSchema = hunSchema.concat(baseSchema);

export type InputStore = Asserts<typeof inputSchema>;

const defaultState = inputSchema.getDefault() as InputStore;

export const useHunInputStore = genericStoreFactory(
  defaultState,
  'HunInputStore',
);
